// 개정본 비교(Revision Diff) 공통 상수·라벨. 업로드 제약과 필드 표시 규칙을
// 업로드 폼·diff 뷰어·훅이 공유한다(하드코딩 분산 방지).

// 업로드 제약(안내·검증 공통).
export const MAX_FILE_MB = 10
export const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

// 필드 라벨(영문 키 → 한글). CatalogItemInput 필드와 정렬한다.
export const FIELD_LABELS: Record<string, string> = {
    part: '파트',
    classification: '분류',
    scale: '규모',
    assessmentType: '평가 유형',
    industry: '업종',
    majorCategory: '대분류',
    middleCategory: '중분류',
    itemNumber: '항목번호',
    title: '제목',
    maxScore: '배점',
    scoringScale: '채점 척도',
    guidance: '안내(guidance)',
    dataType: '데이터 타입',
    scoringLogic: '채점 로직',
    isDeterministic: '결정형',
}

// 채점에 직접 영향을 주는 필드(배지로 강조). 편집기와 동일한 기준.
export const SCORING_FIELDS = new Set(['maxScore', 'scoringLogic', 'isDeterministic'])

// 긴 텍스트라 기본 접어 두는 필드.
export const LONG_FIELDS = new Set([
    'title',
    'scoringScale',
    'guidance',
    'scoringLogic',
])

export const TAB_ITEMS = [
    { key: 'modified', label: '수정' },
    { key: 'added', label: '추가' },
    { key: 'removed', label: '삭제' },
] as const
export type TabKey = (typeof TAB_ITEMS)[number]['key']

// 추가 항목 키(인덱스 기반 — 추가 항목엔 id가 없다).
export const addedKey = (i: number) => `added-${i}`
